import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectOptions"]

  toggle(event) {
    const fieldType = event.currentTarget.value

    // First try to find within a nested-fields container (for nested forms)
    const nestedFieldsContainer = event.currentTarget.closest('.nested-fields')

    let selectOptionsField = null

    if (nestedFieldsContainer) {
      // Nested form case
      selectOptionsField = nestedFieldsContainer.querySelector('[data-field-type-target="selectOptions"]')
    } else if (this.hasSelectOptionsTarget) {
      // Standalone form case - use Stimulus target
      selectOptionsField = this.selectOptionsTarget
    } else {
      // Fallback - search within controller element
      selectOptionsField = this.element.querySelector('[data-field-type-target="selectOptions"]')
    }

    if (selectOptionsField) {
      selectOptionsField.style.display = fieldType === "select" ? "" : "none"
    }
  }
}
